export const queryMap = new Map([['frequencyType', 'type']]);
